import axios from 'axios';
import type { Persona } from '@eleg360/types';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const personaApi = {
  get: async (token: string) => {
    const res = await axios.get<Persona>(`${API_URL}/oto/persona`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  update: async (data: Partial<Persona>, token: string) => {
    const res = await axios.put<Persona>(`${API_URL}/oto/persona`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};
